import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const OccupancyBasic = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({occup: nextData.occup, state: 'basic'}, props.field, props.rowData)
  }

  const unnested_attrs = (field) => field_attrs('room')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Occupancy %</label>
          <NumberInput className="automated" data={data} attrs={unnested_attrs} field="occup" readPrecision={4} writePrecision={4} persist={updateData} min={1} max={100} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default OccupancyBasic
